import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import { ExternalTrainingReport } from '../../models/external-training-report'
import { ExcelService } from '../../excel.service'
import { ExternlaTrainingSearchCriteria } from '../../models/external-training-search-criteria'
import * as moment from 'moment'
import { PortalGlobals } from '../../../../app/portalglobals'

@Component({
    selector: 'ExternalTraining',
    templateUrl: 'external-training.component.html'
})
export class ExternalTrainingComponent implements OnInit {
    public loading = false
    ExternalTrainingReportViewModel: ExternalTrainingReport[] = new Array<ExternalTrainingReport>()
    message = ''
    StartDate: Date
    EndDate: Date
    saveSuccess: string
    exportExcel
    IsrecordFound
    serviceResponse
    ExternalTrainingSearchCriteriaVM: ExternlaTrainingSearchCriteria
    @ViewChild('gridReference', { static: true }) myGrid: jqxGridComponent
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    source: any = {
        dataFields: [
            { name: 'UserProfileName', type: 'string' },
            { name: 'ExternalTrainingID', type: 'string' },
            { name: 'FirstName', type: 'string' },
            { name: 'LastName', type: 'string' },
            { name: 'CUID', type: 'string' },
            { name: 'OrgName', type: 'string' },
            { name: 'CourseName', type: 'string' },
            { name: 'Title', type: 'string' },
            { name: 'Description', type: 'string' }
        ],
        dataType: 'json',
        localData: this.ExternalTrainingReportViewModel
    }
    dataAdapter: any = new jqx.dataAdapter(this.source)

    columns: any[] = [
        { text: "Agent's LoginID", dataField: 'UserProfileName', width: 150 },
        { text: 'ExternalTrainingID', dataField: 'ExternalTrainingID', hidden: true },
        { text: "Agent's First Name", dataField: 'FirstName', width: 110 },
        { text: "Agent's Last Name", dataField: 'LastName', width: 111 },
        { text: 'CUID', dataField: 'CUID', width: 56 },
        { text: 'Organization', dataField: 'OrgName', width: 165 },
        { text: 'Course ID', dataField: 'CourseName', width: 90 },
        { text: 'Course Title', dataField: 'Title', width: 180 },
        { text: 'Error Type or reason for failure', dataField: 'Description', width: 360 }
    ]

    constructor(private _reportsGateway: ReportsGateway, private excelService: ExcelService, public _global: PortalGlobals) {
        this.excelService = excelService
    }

    ngOnInit(): void {
        this.ExternalTrainingSearchCriteriaVM = {} as ExternlaTrainingSearchCriteria
        let today = new Date()
        var year = 0
        if (this._global.selectedPlanYear == undefined || this._global.selectedPlanYear == null || this._global.selectedPlanYear == 0) {
            year = Number(localStorage.getItem('curPlanYear'))
        } else {
            localStorage.setItem('curPlanYear', this._global.selectedPlanYear.toString())
            year = this._global.selectedPlanYear
        }

        var month = 9
        var day = 1
        this.ExternalTrainingSearchCriteriaVM.startDate = moment().date(day).month(month).year(year).subtract('years', 1).toDate()
        this.ExternalTrainingSearchCriteriaVM.endDate = today
        this.saveSuccess = ''
    }

    getExternalTrainingReport() {
        this.loading = true
        this._reportsGateway.getExternalTrainingReport(this.ExternalTrainingSearchCriteriaVM).subscribe(
            (comLevelModel: ExternalTrainingReport[]) => {
                console.log(comLevelModel)
                if (comLevelModel != null) {
                    this.ExternalTrainingReportViewModel = comLevelModel
                    this.source.localdata = this.ExternalTrainingReportViewModel
                    this.dataAdapter.dataBind()
                    this.myGrid.updatebounddata()
                } else {
                    this.message = 'Unable to load formulary updates'
                }
                this.loading = false
            },
            (error) => {
                this.loading = false
            }
        )
    }

    //CellclickOnEdit(event: any): void {

    //}

    //cellEndEditEvent(event: any): void {

    //}

    exportToExcel() {
        this._reportsGateway.getExternalTrainingReport(this.ExternalTrainingSearchCriteriaVM).subscribe((comLevelModel: ExternalTrainingReport[]) => {
            this.exportExcel = comLevelModel
            if (comLevelModel.length === 0) {
                this.IsrecordFound = true
                this.serviceResponse = 'No Record Found'
            } else {
                this.excelService.exportAsExcelFile(this.changeName(this.exportExcel), 'Report')
                this.IsrecordFound = false
            }
        })
    }

    changeName(exportExcel: ExternalTrainingReport[]): ExternalTrainingReport[] {
        var json: ExternalTrainingReport[]
        var str = JSON.stringify(exportExcel)
        str = str.replace(/\"UserProfileName\":/g, '"Agent\'s LoginID":')
        str = str.replace(/\"FirstName\":/g, '"Agent\'s First Name":')
        str = str.replace(/\"LastName\":/g, '"Agent\'s Last Name":')
        str = str.replace(/\"OrgName\":/g, '"Organization":')
        str = str.replace(/\"CourseName\":/g, '"Course ID":')
        str = str.replace(/\"Title\":/g, '"Course Title":')
        str = str.replace(/\"Description\":/g, '"Error Type or reason for failure":')
        json = JSON.parse(str)
        return json
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.getExternalTrainingReport()
        }
    }
}
